module.exports = __webpack_public_path__ + "static/img/flower.31cb11e.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/inventory/stickers/flower.png
// module id = Ijz4
// module chunks = 0